import React, {ReactNode, useEffect} from 'react'
import ReactDOM from 'react-dom'

export const Portal = ({
  children,
  parent,
  className
}: {
  children: ReactNode
  parent?: HTMLElement
  className: string
}) => {
  const el = React.useMemo(() => document.createElement('div'), [])
  useEffect(() => {
    const target = parent ?? document.body
    const classList = ['portal-container']
    if (className) className.split(' ').forEach(item => classList.push(item))
    classList.forEach(item => el.classList.add(item))
    target.appendChild(el)
    return () => {
      target.removeChild(el)
    }
  }, [el, parent, className])
  return ReactDOM.createPortal(children, el)
}
